/**
 * The words a line item's own screen says about itself (PR 3 of
 * audits/2026-10-29/gui/plan.md): its panels and the buttons that open and leave it —
 * where things are, nothing about X. What the screen says about X stays in
 * `targeting-copy.ts`, `creative-copy.ts` and `line-item-copy.ts`.
 *
 * 🔴 The screen is opened by `OPEN_LINE_ITEM` on the line item's row in the Line items
 * panel, and the sentences that send someone to a switch name that button and these
 * panels: `WRITES_HERE`, `PAUSE_FIRST`, `LINE_ITEMS_HERE`, `ORDER`, `creativeHint`,
 * `NO_TARGETING`, `createdText`, `stoppedText`. Renaming one here is renaming a place
 * those sentences name; `line-item-screen.test.ts` holds them to these words.
 */

/** On the line item's row: the button that opens its screen, both ways. */
export const OPEN_LINE_ITEM = "Open";
/** At the top of the screen: back to the list, where the New line item form is. */
export const BACK_TO_LINE_ITEMS = "All line items";

export const LINE_ITEM_PANEL = "Line item";
export const TARGETING_PANEL = "Targeting";
export const ADD_CRITERION_PANEL = "Add criterion";
export const ADS_PANEL = "Ads";

/**
 * The two switches, in the line item panel's header. Bare verbs because the header names
 * the one object they act on (B2, decided by -3d on 2026-10-29: «Pause» replaces «Stop»
 * wherever the act is entity_status PAUSED; a bare «Start» only where one object is named
 * in the header).
 */
export const START = "Start";
export const PAUSE = "Pause";

/** The folded line over what the two switches ask and the one thing checked before a start. */
export const SWITCHES_FOLD = "What Start and Pause ask, and what is checked first";

/** Before the campaign's status in the line item panel's header. */
export function underCampaign(campaignId: string): string {
	return `under campaign ${campaignId}`;
}

/** The folded line under the Ads panel's banner: why a creative is attached only while PAUSED. */
export const ATTACHING_FOLD = "Why only while the line item is PAUSED, and whose act a start is";
